/* Wardati (v14) : animations au défilement et petites interactions. Voir wardati-motion.css. */
(function () {
  var html = document.documentElement;
  window.__wMotion = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) { html.classList.remove('w-motion'); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function mark(el, kind, i) {
    if (!el || el.hasAttribute('data-w-reveal') || el.classList.contains('is-in')) return;
    el.setAttribute('data-w-reveal', kind || '');
    if (i != null) el.style.setProperty('--w-i', i);
    io.observe(el);
  }
  function watch(el) { if (el && !el.__wSeen) { el.__wSeen = true; io.observe(el); } }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function stagger(sel, kind) {
    var groups = new Map();
    all(sel).forEach(function (el) {
      if (el.hasAttribute('data-w-reveal')) return;
      var p = el.parentElement; var n = groups.get(p) || 0; groups.set(p, n + 1);
      mark(el, kind, n % 6);
    });
  }

  function heroSplit() {
    var hero = document.querySelector('.w-hero');
    if (!hero || hero.__wDone) return;
    hero.__wDone = true;
    var h1 = hero.querySelector('h1');
    if (h1 && !h1.querySelector('.w-line')) {
      var words = h1.textContent.trim().split(/\s+/);
      h1.innerHTML = words.map(function (w) { return '<span class="w-wtmp">' + w + '</span>'; }).join(' ');
      var lines = [], top = null;
      all('.w-wtmp', h1).forEach(function (s) {
        if (top === null || Math.abs(s.offsetTop - top) > 4) { lines.push([]); top = s.offsetTop; }
        lines[lines.length - 1].push(s.textContent);
      });
      h1.setAttribute('aria-label', words.join(' '));
      h1.innerHTML = lines.map(function (l, i) {
        return '<span class="w-line" aria-hidden="true" style="--w-i:' + i + '"><span>' + l.join(' ') + '</span></span>';
      }).join('');
    }
    var img = hero.querySelector('.w-hero__img');
    if (img) mark(img, 'img');
    requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-in'); if (img) img.classList.add('is-in'); }); });
  }

  function quoteSplit() {
    var q = document.querySelector('.w-quote');
    if (!q || q.__wDone) return;
    q.__wDone = true;
    var bq = q.querySelector('blockquote');
    if (bq && !bq.querySelector('.w-word')) {
      var text = bq.textContent.trim();
      bq.setAttribute('aria-label', text);
      bq.innerHTML = text.split(/\s+/).map(function (w, i) {
        return '<span class="w-word" aria-hidden="true" style="--w-i:' + i + '">' + w + '</span>';
      }).join(' ');
    }
    watch(q);
    var img = q.querySelector('.w-quote__img');
    if (img) mark(img, 'img');
    var pic = img && img.querySelector('img');
    if (pic && window.matchMedia('(min-width: 750px)').matches) {
      pic.style.height = '116%'; pic.style.top = '-8%';
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var r = img.getBoundingClientRect(), vh = window.innerHeight;
          if (r.bottom < 0 || r.top > vh) return;
          var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
          pic.style.transform = 'translate3d(0,' + (p * -6).toFixed(2) + '%,0)';
        });
      }, { passive: true });
    }
  }

  function strokes() {
    all('.w-reassure__item').forEach(function (item, i) {
      if (item.__wDone) return; item.__wDone = true;
      all('path, circle, rect', item).forEach(function (s) {
        try { var L = Math.ceil(s.getTotalLength()) + 1; s.setAttribute('data-w-len', ''); s.style.setProperty('--w-len', L); } catch (e) {}
      });
      item.style.setProperty('--w-i', i);
      watch(item);
    });
  }

  function steps() {
    var grid = document.querySelector('.w-steps__grid');
    if (!grid || grid.__wDone) return; grid.__wDone = true;
    all('.w-step__num', grid).forEach(function (n, i) { n.style.setProperty('--w-i', i); });
    watch(grid);
  }

  function cardWriting() {
    var ta = document.querySelector('textarea[name="properties[Message]"]');
    var card = document.querySelector('.w-card-preview');
    if (!ta || !card || ta.__wDone) return; ta.__wDone = true;
    ta.addEventListener('focus', function () { card.classList.add('is-writing'); });
    ta.addEventListener('blur', function () { card.classList.remove('is-writing'); });
  }

  function run() {
    heroSplit();
    quoteSplit();
    strokes();
    steps();
    all('.w-h2, .w-cols__head, .w-occ__intro, .w-reviews-head__left, .w-occp-intro').forEach(function (el) { mark(el); });
    stagger('.w-cols__grid > li, .w-occp__card, .w-step__title, .w-occ__chips a');
    stagger('main .product-card');
    stagger('.blog-post-card, .featured-blog-posts article');
    all('.w-cols__occ').forEach(function (el) { mark(el); });
    cardWriting();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 120); })
    .observe(document.body || html, { childList: true, subtree: true });
  document.addEventListener('pageshow', run);
})();
